import { MessagingActivityItemType } from "@src/types.generated";

export const POST_ACTIVITY_TYPES: MessagingActivityItemType[] = [
  MessagingActivityItemType.NewPost,
  MessagingActivityItemType.NewAutomatedPost,
  MessagingActivityItemType.NewPostReaction,
  MessagingActivityItemType.NewPostComment,
  MessagingActivityItemType.PostCommentMention,
  MessagingActivityItemType.PostMention,
];
